<template>
    <div class="form-upload-wrap" v-if="uploading">
        アップロード中です...
    </div>
    <template v-else>
        <div class="row">
            <template v-if="answer_files.length">
                <template v-for="(file, index) of answer_files" :key="file">
                    <div class="col-12 mb-3 text-center position-relative">
                        <img :src="file.thumbnail_url" alt="">
                        <button type="button" class="btn-close position-absolute top-0 end-0" @click="remove(index)"></button>
                    </div>
                </template>
            </template>
            <div class="col-12 mb-3">
                <label class="work-upload">
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        @change="upload"
                        style="display:none;"
                    >
                    <div class="text-center">
                        <i class="bi bi-camera"></i> {{ $t('さつえい') }}<br>
                        <small>{{ $t('または') }}</small><br>
                        <i class="bi bi-folder"></i> {{ $t('選たく') }}
                    </div>
                </label>
            </div>
        </div>

    </template>
</template>

<script>
import File from '@/shared/models/entities/file';

export default {
    name: 'FormUploadQuestion',
    data() {
        return {
            upload_type:  'repocraft/question',
            //アップロード中
            uploading: false,
            //ファイルオブジェクトの配列 (通常はmodelValueのコピー)
            answer_files: [],
        }
    },
    props: {
        modelValue: {
            type: Array,
        },
    },
    emits: [
        'update:modelValue'
    ],
    mounted() {
        if (this.modelValue.length) {
            for (let file of this.modelValue) {
                this.answer_files.push(file);
            }
        }
    },
    watch: {
        modelValue() {
            this.answer_files = this.modelValue;
        }
    },
    methods: {
        //ファイルアップロード→成功したら emit
        upload(event) {
            let formData = new FormData()
            let uploading_files = event.target.files;

            for (let uploading_file of uploading_files) {
                formData.append('file[]', uploading_file);
            }

            this.uploading = true;

            let headers = {
                'content-type': 'multipart/form-data'
            };
            this.$http.post('/repocraft/question/upload', formData, {headers})
            .then(response => {
                for (let row of response.data) {
                    this.answer_files.push(new File(row));
                }
                this.$emit('update:modelValue', this.answer_files);
            })
            .finally(() => {
                this.uploading = false;
            });
        },
        //ファイルを外す
        remove(index) {
            this.answer_files.splice(index, 1);
            this.$emit('update:modelValue', this.answer_files);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .work-upload {display: flex; justify-content: center; align-items: center; gap: 0.3rem; height: 100%; min-height: 5rem; border: 5px solid #0d6efd; color: #0d6efd; border-radius: 0.5rem;}
    .work-upload input {display: none;}

</style>